import Typography from 'components/OnahTypography';
import React, { FC } from 'react';
import { ReactComponent as Alert } from "assets/svgs/alert.svg";

type IOnahInputErrorrProps = {
    error?: string;
    showError?: boolean
};

const OnahInputError: FC<IOnahInputErrorrProps> = ({error, showError}) => {
    if(!showError) {
        return null;
    }
    return (
        <Typography variant="textXs" className="!text-error-700 mt-[5px] flex items-center"><Alert className="!text-error-700 inline-block mr-1 text-base leading-4"/>{error}</Typography>
    );  
};

export default OnahInputError;